import React, { useState, useEffect, useContext } from 'react';
import './style.css';
import RiskOverviewStandardSectionHeader from '/src/Components/RiskOverviewStandardSectionHeader/RiskOverviewStandardSectionHeader';
// import RiskOverviewStandardSectionHeader from '../../../../Components/RiskOverviewStandardSectionHeader/RiskOverviewStandardSectionHeader';
import RiskModal from './Modal/RiskModal';
import { AreaDataContext } from '../../PropertyExplorer';
import { CreateGoogleMapsStreetviewUrl } from '/src/services/CreateGoogleMapsStreetviewUrl';
import { AddressSearchContext, WindowSizeContext } from '/src/App';

import RiskOverviewSectionLoadingState from '/src/Components/RiskOverviewSectionLoadingState/RiskOverviewSectionLoadingState';
const WhichRisksToFocusOn = ({ propertyData, title }) => {

    const propertyDetails = propertyData?.data?.property_details;
    const latitude = propertyDetails?.lat;
    const longitude = propertyDetails?.long;
    const streetviewImageUrl = CreateGoogleMapsStreetviewUrl(latitude, longitude);
    const staticMapImageUrl = CreateGoogleMapsStreetviewUrl(latitude, longitude, 'map');

    const [selectedRisk, setSelectedRisk] = useState(null);
    const { contentLoaded } = useContext(AreaDataContext);
    const { deviceType } = useContext(WindowSizeContext);
    const section_intro = "Now let's zoom in to this specific property. Using property-specific climate data, we assessed not only the <i>likelihood</i> of any given risk, but more importantly the potential <i><b>financial impact</b></i> of each. Sometimes that means we highlight risks that may not appear as pressing when looking at the county level. Below are the risks we believe should be focused on for this home:"

    // if (!contentLoaded) {
    //     return <RiskOverviewSectionLoadingState title={title} intro_sentence={section_intro} />;
    // }

    const getRiskBackgroundColor = (riskLevel) => {
        switch (riskLevel.toLowerCase()) {
            case 'high':
                return 'var(--related_red)';
            case 'medium':
                return 'var(--yellow)';
            case 'low':
                return 'var(--accent_light)';
            default:
                return 'transparent';
        }
    };

    const climateRisks = propertyData?.data?.climate_risks || [];

    // Sort the risks (High --> Medium --> Low based on the risk_level key)
    const sortedRisks = climateRisks.sort((a, b) => {
        const order = ['High', 'Medium', 'Low'];
        return order.indexOf(a.risk_level) - order.indexOf(b.risk_level);
    });

    // Filter the risks into High, Medium, and Low
    const highRisks = sortedRisks.filter(risk => risk.risk_level === 'High');
    const mediumRisks = sortedRisks.filter(risk => risk.risk_level === 'Medium');
    const lowRisks = sortedRisks.filter(risk => risk.risk_level === 'Low');

    const risksToFocusOnArray = []

    if (highRisks.length > 0) {
        risksToFocusOnArray.push({
            label: 'Potential for Large Financial Impact',
            css: 'high',
            risks: highRisks
        });
    }
    if (mediumRisks.length > 0) {
        risksToFocusOnArray.push({
            label: 'Potential for Moderate Financial Impact',
            css: 'medium',
            risks: mediumRisks
        });
    }
    if (lowRisks.length > 0) {
        risksToFocusOnArray.push({
            label: 'Potential for Low Financial Impact',
            css: 'low',
            risks: lowRisks
        });
    }

    return (
        <div className="tab-content-container">
            <RiskOverviewStandardSectionHeader title={title} />
            <div className="risks-to-focus-on-section-intro-container">
                <div className={`risks-to-focus-on-section-streetview-map-container ${deviceType}`}>
                    <div className={`risks-to-focus-on-section-streetview-container ${deviceType}`}>
                        <img src={streetviewImageUrl} alt="Streetview" />
                    </div>
                    {deviceType !== 'mobile' && (
                        <div className={`risks-to-focus-on-section-streetview-container ${deviceType}`}>
                            <img src={staticMapImageUrl} alt="Map" />
                        </div>
                    )}
                </div>
                <p className="text-align-center" dangerouslySetInnerHTML={{ __html: section_intro }} />
            </div>
            <div className="risks-to-focus-on-sections-grid">
                {risksToFocusOnArray.map((section, index) => {
                    return (
                        <div className={`risks-to-focus-on-section ${deviceType} ${section.css}`}>
                            <div className={`risks-to-focus-on-section-label ${section.css}`}>{section.label}</div>
                            <div className={`risks-to-focus-on-section-items-container ${deviceType}`}>
                                {section.risks.map((risk, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className="risk-item risks-to-focus-on-item"
                                        >
                                            <div
                                                className="which-risks-to-focus-on-icon-container box-shadow-standard"
                                                style={{
                                                    backgroundColor: getRiskBackgroundColor(risk.risk_level)
                                                }}
                                            >
                                                <img
                                                    src={`${import.meta.env.VITE_CONTENT_CDN_BASE_URL}/${risk.icon_white}`}
                                                    alt={risk.risk_name}
                                                    className="risk-icon"
                                                />
                                            </div>
                                            <span className="risk-name">{risk.risk_name}</span>
                                            <button
                                                className="which-risks-to-focus-on-risk-learn-more-button box-shadow-standard"
                                                onClick={() => setSelectedRisk(risk)}
                                            >
                                                Learn More
                                            </button>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })}
            </div>
            {/* <div className="risks-grid">
                {sortedRisks.length > 0 && sortedRisks.map((risk, index) => {

                    const riskLevelText = risk.risk_level === 'Medium' ? 'Moderate' : risk.risk_level;
                    return (
                        <div
                            key={index}
                            className="risk-item risks-to-focus-on-item"
                        >
                            <div
                                className="which-risks-to-focus-on-icon-container box-shadow-standard"
                                style={{
                                    backgroundColor: getRiskBackgroundColor(risk.risk_level)
                                }}
                            >
                                <img
                                    src={`${import.meta.env.VITE_CONTENT_CDN_BASE_URL}/${risk.icon_white}`}
                                    alt={risk.risk_name}
                                    className="risk-icon"
                                />
                            </div>
                            <span className="risk-name">{risk.risk_name}</span>
                            <div className={`text-align-center which-risks-to-focus-on-financial-impact-container ${risk.risk_level.toLowerCase()}`}>
                                Potentially {riskLevelText} Financial Impact
                            </div>
                            <button
                                className="which-risks-to-focus-on-risk-learn-more-button box-shadow-standard"
                                onClick={() => setSelectedRisk(risk)}
                            >
                                Learn More
                            </button>
                        </div>
                    )
                })}
            </div> */}
            {selectedRisk && (
                <RiskModal
                    risk={selectedRisk}
                    onClose={() => setSelectedRisk(null)}
                />
            )}
        </div>
    );
};

export default WhichRisksToFocusOn;